import React, { useState, useRef, useEffect, startTransition } from "react";
import MobileAside from "../aside/MobileAside";
import { selectBellNotificationCount } from "../../redux/slices/bellNotificationSlice";
import { setLoginData } from "../../redux/slices/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NotificationDropdown from "../notificathion/NotificationDropdown";
import { FaBell } from "react-icons/fa6";
import { IoPerson, IoMenu } from "react-icons/io5";
import { FaTimes } from "react-icons/fa";
import LanguageSelect from "./../languageMenu/LanguageMenu";
import DarkModeSwitch from "./../DarkModeSwitch/DarkModeSwitch";
// import { BsBarChartLineFill } from "react-icons/bs";
import { IoMdSettings } from "react-icons/io";
import { IoLogOut } from "react-icons/io5";
import { getNotificationsAndNewOrder } from "../../axios/api/OrderApi";
import { setBellNotificationData } from "../../redux/slices/bellNotificationSlice";

const MobileHeader = ({ formatPathname, resolvedLang, partnerinfo }) => {
  const location = useLocation();
  const [isAsideOpen, setIsAsideOpen] = useState(false);
  const [renderAside, setRenderAside] = useState(false);
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const bellRef = useRef(null);
  const LangAndModeSwitchRef = useRef(null);
  const unreadCount = useSelector(selectBellNotificationCount);
  const [open, setOpen] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const profileRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeAside = () => {
    setIsAsideOpen(false);
    setTimeout(() => setRenderAside(false), 300);
  };

  const changeLanguage = (lng) => {
    if (lng === resolvedLang) return;

    const pathParts = location.pathname.split("/");

    if (["am", "ru", "en"].includes(pathParts[1])) {
      pathParts[1] = lng;
    } else {
      pathParts.splice(1, 0, lng);
    }

    const newPath = pathParts.join("/") || `/${lng}`;

    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    localStorage.setItem("partnerAdminLng", lng);

    navigate(newPath);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await getNotificationsAndNewOrder();
        const data = response?.data?.bellNotification;
        if (data) {
          dispatch(setBellNotificationData(data));
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, [dispatch]);

  useEffect(() => {
    setProfileDropdownOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        LangAndModeSwitchRef.current &&
        !LangAndModeSwitchRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [LangAndModeSwitchRef]);

  const handleGoToSettings = () => {
    startTransition(() => {
      navigate(`/${resolvedLang}/settings`, {
        replace: true,
      });
    });
    setProfileDropdownOpen(false);
  };

  return (
    <>
      <div className=" z-20 flex gap-2.5 items-center justify-end mt-5 block-background-design-header h-[85px] fixed top-0 w-[-webkit-fill-available] mr-[25px] ">
        <div
          className={`md:hidden grid absolute left-[20px] ${
            location.pathname.split("/")[2] === "dashboard"
              ? "top-[5px]"
              : "top-[28px]"
          }`}
        >
          <h1 className="font-[600] text-[20px] text-primary tracking-wider">
            {formatPathname(location.pathname)}
          </h1>
          {location.pathname.split("/")[2] === "dashboard" && (
            <h1 className="font-[600] text-[25px] text-secondary_black dark:text-white">
              {partnerinfo?.partnerName}
            </h1>
          )}
        </div>
        {/* Render dropdown if open */}
        <div className="relative" ref={profileRef}>
          <div
            onClick={() => setProfileDropdownOpen((prev) => !prev)}
            className="flex gap-2.5 items-center cursor-pointer"
          >
            {/* <span className="font-[500] text-[16px] block whitespace-nowrap overflow-hidden overflow-ellipsis select-none">
              {email || "--"}
            </span> */}

            {partnerinfo?.partnerLogo ? (
              <img
                src={partnerinfo.partnerLogo}
                alt="partner logo"
                className="h-[43px] w-[43px] rounded-full border-[2px] border-[#dcdcdc] shadow-md object-contain block-background-design  transition-all duration-300 hover:brightness-125"
              />
            ) : (
              <div
                className="
                  relative p-2 text-primary
                  flex justify-center items-center
                  h-[43px] w-[43px] rounded-full
                  block-background-design dark:!bg-secondary_black
                  backdrop-blur-[20px]
                  border-[2px] border-[#dcdcdc] dark:border-[#3a3a3a]
                  transition-all duration-300
                  shadow-md
                  hover:brightness-125
                  overflow-hidden
                "
              >
                <IoPerson className="w-6 h-6" />
              </div>
            )}
          </div>

          {/* Profile Dropdown */}
          {profileDropdownOpen && (
            <div className="absolute right-0 mt-3 w-auto block-background-design dark:!bg-secondary_black rounded-lg shadow-md flex flex-col z-50 overflow-hidden">
              <button
                onClick={handleGoToSettings}
                className="flex items-center justify-start px-3 py-2 text-left text-secondary_black dark:text-white hover:bg-secondary_black hover:text-white dark:hover:bg-secondary_black transition select-none"
              >
                <IoMdSettings className="mr-2" />
                {t("settings")}
              </button>

              <button
                onClick={() => {
                  localStorage.removeItem("userPartnerData");
                  setLoginData(false);
                  navigate(`/${resolvedLang}/`);
                }}
                className="flex items-center justify-start px-3 py-2 text-left text-secondary_black dark:text-white hover:bg-secondary_black hover:text-white dark:hover:bg-secondary_black transition select-none"
              >
                <IoLogOut className="mr-2" />
                {t("logout")}
              </button>
            </div>
          )}
        </div>
        <div className="relative" ref={bellRef}>
          <button
            onClick={toggleDropdown}
            className="
              relative p-2 text-primary
              flex justify-center items-center
              h-[43px] w-[43px] rounded-full
              block-background-design dark:!bg-secondary_black
              backdrop-blur-[20px]
              border-[2px] border-[#dcdcdc] dark:border-[#3a3a3a]
              transition-all duration-300
              shadow-md
              hover:brightness-125
              overflow-hidden
            "
            aria-label="Pending services"
          >
            {/* Bell icon */}
            <FaBell className="h-6 w-6" />
          </button>
          {unreadCount != 0 && (
            <div className="px-1 bg-primary rounded-full text-center text-white prose-t11_regular absolute left-[30px] top-[2px] w-[16px] h-[16px] z-20">
              {unreadCount}
              <div className="absolute top-0 start-0 rounded-full -z-10 animate-ping bg-primary w-full h-full"></div>
            </div>
          )}
          {dropdownOpen && (
            <div
              className={`absolute right-[-70px] mt-6 w-[335px] h-[200px] 
              ${unreadCount === 0 ? "overflow-auto" : "overflow-scroll"} 
              block-background-design dark:!bg-secondary_black 
              rounded-lg shadow-lg p-3 flex flex-col gap-4 z-50 border-none`}
            >
              <NotificationDropdown
                setDropdownOpen={setDropdownOpen}
                ignoreRef={bellRef}
              />
            </div>
          )}
        </div>
        <div className="relative inline-block" ref={LangAndModeSwitchRef}>
          <button
            onClick={() => setOpen((prev) => !prev)}
            className="
              relative p-2 text-primary
              flex justify-center items-center
              h-[43px] w-[43px] rounded-full
              block-background-design dark:!bg-secondary_black
              backdrop-blur-[20px]
              border-[2px] border-[#dcdcdc] dark:border-[#3a3a3a]
              transition-all duration-300
              shadow-md
              hover:brightness-125
              overflow-hidden
            "
            aria-label="Language and dark mode toggle menu"
          >
            {open ? (
              <FaTimes className="h-6 w-6" />
            ) : (
              <IoMenu className="h-6 w-6" />
            )}
          </button>

          {/* Dropdown */}
          {open && (
            <div className="absolute right-0 mt-4 w-[135px] block-background-design dark:!bg-secondary_black rounded-lg shadow-lg p-3 flex flex-col gap-4 z-50">
              <LanguageSelect onChange={changeLanguage} />
              <DarkModeSwitch />
            </div>
          )}
        </div>
      </div>

      {renderAside && <MobileAside isOpen={isAsideOpen} onClose={closeAside} />}
    </>
  );
};

export default MobileHeader;
